import PropTypes from 'prop-types';
import React from 'react';
import { Typography } from '@sm/wds-react';

import EnterprisePackageCta from '../EnterprisePackageCta';

const EnterprisePackageHeader = ({ details }) => (
  <header className="sm-package__header" data-testid="EnterprisePackageHeader__Header">
    <Typography
      component="h1"
      variant="sectionTitle"
      className="sm-package__title"
      data-testid="EnterprisePackageHeader__HeaderText"
    >
      {details.displayName.toUpperCase()}
    </Typography>
    <Typography component="h2" variant="body" className="sm-package__byline">
      Powerful admin tools, integrations, and collaboration features for your organization.
    </Typography>
    <EnterprisePackageCta />
  </header>
);

EnterprisePackageHeader.propTypes = {
  details: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
};

export default EnterprisePackageHeader;
